// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"427ced71","703":"aa3475d0","787":"144a3bd9"}[chunkId] + ".chunk.js";
};